import { useState } from "react";
import { useDeleteQuery } from "../hooks";
import Panel from "./Panel";
import Grid from "./Grid";
import Modal from "./Modal";
import DeleteButton from "./DeleteButton";
import EditButton from "./EditButton";
import JobAdd from "./JobAdd";
import JobEdit from "./JobEdit";
import ConfirmationModal from "./ConfirmationModal";
import Actions from "./Actions";
import AddButton from "./AddButton";
import Avatar from "./Avatar";
import { useDataContext } from "../contexts";

export default function JobCRUD() {
  const { getMemberUserById, jobs } = useDataContext();
  const [addModalOpen, setAddModalOpen] = useState(false);
  const [editModalId, setEditModalId] = useState(null);
  const [deleteModalId, setDeleteModalId] = useState(null);

  const deleteJob = useDeleteQuery("jobs");

  function renderAvailableUsers(job) {
    return (
      <div className="flex gap-2">
        {job.availableTo
          .map((id) => getMemberUserById(id))
          .filter((user) => user)
          .map((user) => (
            <Avatar key={user.id} name={user.name} />
          ))}
      </div>
    );
  }

  return (
    <Panel left="Jobs">
      <Grid
        data={jobs}
        columnsTemplate="justify-between grid-cols-[auto_auto_auto_auto]"
        renderTestId={(job) => `Job ${job.name}`}
        columns={[
          { header: "Name", key: "name" },
          {
            header: "Members",
            render: renderAvailableUsers,
          },
          { header: "Reward", key: "rewardAmount" },
          {
            header: "Actions",
            render: (job) => (
              <Actions>
                <EditButton key="edit" onClick={() => setEditModalId(job.id)} />
                <DeleteButton
                  key="delete"
                  onClick={() => setDeleteModalId(job.id)}
                />
              </Actions>
            ),
          },
        ]}
      />
      <AddButton className="mt-4" onClick={() => setAddModalOpen(true)} />
      <Modal
        isOpen={addModalOpen}
        onClose={() => setAddModalOpen(false)}
        heading="Add Job"
      >
        <JobAdd callback={() => setAddModalOpen(false)} />
      </Modal>
      <Modal
        isOpen={editModalId !== null}
        onClose={() => setEditModalId(null)}
        heading="Edit Job"
      >
        {editModalId && (
          <JobEdit id={editModalId} callback={() => setEditModalId(null)} />
        )}
      </Modal>
      <ConfirmationModal
        isOpen={deleteModalId !== null}
        onClose={() => setDeleteModalId(null)}
        heading="Delete Job"
        message="Are you sure you want to delete this job?"
        confirmLabel="Delete"
        onConfirm={() => {
          deleteJob.mutate(deleteModalId);
          setDeleteModalId(null);
        }}
      />
    </Panel>
  );
}
